import { useState } from 'react';

import { createSearchParams, useNavigate } from 'react-router';

import { Box, Button, CircularProgress } from '@mui/material';
import { useIsFetching } from '@tanstack/react-query';

import { ConfirmModal } from 'components/modal';
import { CurrencyText, SubTitle, WeightText } from 'components/text';
import { useApplicationContext } from 'context/ApplicationContext';
import { usePedidoCompraContext } from 'context/PedidoCompraContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { useBreakpoints } from 'hooks/useBreakpoints';

export function PedidoCartInfo() {
    const { carrinhoChanged, initialTotalizador, vlPedido, vlPesoLiquido, totalizador, loja, configPedido, funcionario } = usePedidoCompraContext();
    const navigate = useNavigate();
    const [openConfirmModal, setOpenConfirmModal] = useState<boolean>(false);
    const { hasPermission } = usePermissionsContext();
    const hasPermissionFinalizacaoGeral = hasPermission(['COMPRA_PEDIDO_FINALIZACAO_GERAL']);
    const { user } = useApplicationContext();
    const { isUpLg } = useBreakpoints();
    const isFetching = Boolean(useIsFetching({ queryKey: ['pedido-totalizador'] }));

    const vlTotalTotalizador = totalizador.vlTotal - initialTotalizador.vlTotal + vlPedido;
    const vlPesoLiquidoTotalTotalizador = totalizador.vlPesoLiquidoTotal - initialTotalizador.vlPesoLiquidoTotal + vlPesoLiquido;

    const navigateRascunho = () => {
        navigate({
            pathname: '/compra/carrinho',
            search: createSearchParams({
                ...(loja && { idLoja: JSON.stringify([loja]) }),
                ...((funcionario || user) && hasPermissionFinalizacaoGeral && { idUsuarioPedido: JSON.stringify(funcionario || user) }),
            }).toString(),
        });
    };

    return (
        <>
            <ConfirmModal
                open={openConfirmModal}
                setOpen={setOpenConfirmModal}
                text="Ao visualizar o carrinho, você perderá todas as alterações não salvas no pedido atual. Deseja continuar?"
                confirm={navigateRascunho}
            />

            <Box sx={{ display: 'flex', flexDirection: { xs: 'row-reverse', lg: 'column' }, gap: 2 }}>
                {isUpLg && <SubTitle label="Meu Carrinho" fullWidth sx={{ mb: 0 }} />}

                <Button
                    variant="outlined"
                    sx={{ flex: 1 }}
                    onClick={() => {
                        if (carrinhoChanged) {
                            setOpenConfirmModal(true);
                        } else {
                            navigateRascunho();
                        }
                    }}
                >
                    Meus pedidos pendentes
                </Button>

                {isFetching && (
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress size={20} />
                    </Box>
                )}

                {!isFetching && configPedido && (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <WeightText size="sm" value={vlPesoLiquidoTotalTotalizador} label="Peso total" />

                        <CurrencyText size="sm" value={vlTotalTotalizador} label="Valor total" />
                    </Box>
                )}
            </Box>
        </>
    );
}
